import { createFileRoute } from '@tanstack/react-router';
import { CharacterSheetPage } from '../../../sheets/pc/CharacterSheetPage.js';
import { validateCharacterSheetSearch } from '../../../sheets/pc/href.js';

/** `/sheets/pc/$docId` (2.H deliverable 5): one page's PC sheet; `sheet` picks which. */
export const Route = createFileRoute('/sheets/pc/$docId')({
  validateSearch: validateCharacterSheetSearch,
  component: CharacterSheetRoute,
});

function CharacterSheetRoute(): React.JSX.Element {
  const { docId } = Route.useParams();
  const { sheet } = Route.useSearch();
  return (
    <main className="cx-pc-page">
      <CharacterSheetPage docId={docId} sheetId={sheet} />
    </main>
  );
}
